module.exports = __webpack_public_path__ + "static/media/finder.2cb32513.md";